import ReviewItemGroup, {
  ReviewItemGroupProps,
} from "../../components/ReviewItemGroup/ReviewItemGroup.web";

type PublicCheckoutDeliveryItemProps = ReviewItemGroupProps;

/**
 * Syntactic sugar for bridging the delivery UI with the ReviewItemGroup component.
 *
 * Since the Public Checkout delivery method UI/UX is the same as whats in Box Office,
 * this allows for a consistent component structure between Public Checkout and Box Office.
 */
function PublicCheckoutDeliveryItem(
  props: PublicCheckoutDeliveryItemProps
): JSX.Element {
  return <ReviewItemGroup {...props} />;
}

export default PublicCheckoutDeliveryItem;
